import { render, staticRenderFns } from "./HomeFavoris.vue?vue&type=template&id=0a825d47&"
import script from "./HomeFavoris.vue?vue&type=script&lang=ts&"
export * from "./HomeFavoris.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFavoris.vue?vue&type=style&index=0&id=0a825d47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports